import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './PersonalReport/Utils/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;  // Explicitly type the children prop
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
   const auth = useAuth();

  // If no token is found, redirect to the login page
  if (auth.isTokenExpired()) {
    return <Navigate to="/login" replace />;
  }

  // If token exists, render the protected content (children)
  return <>{children}</>;
};

export default ProtectedRoute;
